@switch (displayMode) {
    @case ("Kanban") {
        <div class="fancy-scrollbar-newUI wk-view__container" cdkScrollable>
            @for (columnData of columns; track columnData.id) {
                <column-component
                    [hidden]="columnData.state !== 'completed' || columnData.id === 'all_steps_completed'"
                    [isHidden]="columnData.state !== 'completed' || columnData.id === 'all_steps_completed'"
                    [columnData]="columnData"
                />
            }
        </div>
    }

    @case ("details") {
        <app-assignees-view />
    }

    @case ("List") {
        <div class="wk-view__steps-selector">
            <div class="wk-view__steps-selector--flex">
                <div class="wk-view__steps-selector--label">{{ "ViewComponent.ViewStep" | translate }}{{ "General.Colon" | translate }}</div>
                @for (pillData of listPillInfo; track pillData.id) {
                    <div
                        class="wk-view__step"
                        [class.selected]="selectedStepId === pillData.id"
                        title="{{ pillData.columnName | wkTranslate }}"
                        (click)="stepSelection(pillData.id, pillData.columnName)"
                    >
                        {{ pillData.columnName | wkTranslate }}
                    </div>
                }
            </div>
            <div>
                @if (userCanPrintExport) {
                    <span class="wk-print-button" (click)="printPage()"><i class="fa fa-print fa-inverse" aria-hidden="true"></i></span>
                }
            </div>
        </div>

        <div id="virtual-scroller-wrapper" class="wk-list-virtual-scroller-wrapper">
            <div class="row table-row table-header">
                <div class="col-md-3">
                    @if (isLoadingColumn) {
                        <div class="wk-card-grid-loading-spinner-wrapper wk-taxpayer-count">
                            <app-loader text="General.LoadingCards" [isOverlay]="false" [size]="'button'" />
                        </div>
                    } @else {
                        <i class="fa fa-user wk-taxpayer-count" aria-hidden="true"></i>
                    }
                    {{ "General.Name" | translate }}
                </div>
                <div class="col-md-2">{{ "Board.FamilyMember" | translate }}</div>
                <div class="col-md-2">{{ "CompletedView.ThisYearCompletionDate" | translate }}</div>
                <div class="col-md-2">{{ "CompletedView.LastYearCompletionDate" | translate }}</div>
                <div class="col-md-1">{{ "Dashboard.Category" | translate }}</div>
                <div class="col-md-2">{{ "CompletedView.WorkCycleTime" | translate }}</div>
            </div>
            @for (columnData of columns; track columnData.id) {
                <div [class.single-column]="columnData.state === 'completed'">
                    <column-component [columnData]="columnData" [printing]="printing" [scrollbarGutterStable]="true" />
                </div>
            }
        </div>

        <div class="wk-view__board-returns">
            <i class="fa fa-user wk-taxpayer-count" aria-hidden="true"></i>
            <span> {{ numberOfReturn }} {{ "Board.Returns" | translate }} </span>
            @if (averageDaysInFlow || averageDaysInFlow === 0) {
                <span class="wk-cv__average-work-cycle-time">
                    {{ "CompletedView.AverageWorkCycleTime" | translate }}{{ "General.Colon" | translate }} {{ averageDaysInFlow }}
                </span>
            }
        </div>
    }
}
<router-outlet />
